import { SpecialScaleInfo } from '../../types';

/**
 * A map of scales that need special handling due to their structure
 */
export const SPECIAL_SCALES: Record<string, SpecialScaleInfo> = {
  // Blues scale has a unique structure with duplicate 5th degree
  blues: {
    degrees: [
      { degree: 1, alteration: '', display: '1', semitones: 0 },
      { degree: 3, alteration: 'b', display: 'b3', semitones: 3 },
      { degree: 4, alteration: '', display: '4', semitones: 5 },
      { degree: 5, alteration: 'b', display: 'b5', semitones: 6 },
      { degree: 5, alteration: '', display: '5', semitones: 7 },
      { degree: 7, alteration: 'b', display: 'b7', semitones: 10 },
    ],
  },
  // Major pentatonic uses specific degrees from the major scale
  'major pentatonic': {
    degrees: [
      { degree: 1, alteration: '', display: '1', semitones: 0 },
      { degree: 2, alteration: '', display: '2', semitones: 2 },
      { degree: 3, alteration: '', display: '3', semitones: 4 },
      { degree: 5, alteration: '', display: '5', semitones: 7 },
      { degree: 6, alteration: '', display: '6', semitones: 9 },
    ],
  },
  // Minor pentatonic uses specific degrees from the natural minor scale
  'minor pentatonic': {
    degrees: [
      { degree: 1, alteration: '', display: '1', semitones: 0 },
      { degree: 3, alteration: 'b', display: 'b3', semitones: 3 },
      { degree: 4, alteration: '', display: '4', semitones: 5 },
      { degree: 5, alteration: '', display: '5', semitones: 7 },
      { degree: 7, alteration: 'b', display: 'b7', semitones: 10 },
    ],
  },
};
